<template>
  <!--    银行分支行选择-->
  <div>
    <el-form ref="form" :model="form" :rules="rule_data" :label-width="labelWidth">
      <el-form-item label="开户行" prop="bankNameCode" required>
        <select-page
          :value="form.bankNameCode"
          :disabled="readOnly"
          option-value="finInstitutionCode"
          option-name="bankName"
          placeholder="请选择银行，支持搜索"
          valueName="bankNameCode"
          remoteKey="bankName"
          searchKey="institutionCode"
          @getSelect="setBankName"
          requestUrl="getBankList"
          :request-data="bankListReq"></select-page>
        <label class="form-tip-label" v-show="bankTypeError && !readOnly" style="color: red;"><i class="el-icon-warning"></i>卡号与开户行不匹配，请修改后再提交</label>
        <label v-show="showTips">注：无法搜索到开户行，请选择城市商业银行或农村商业银行</label>
      </el-form-item>
      <el-form-item label="银行网点" required>
        <el-row type="flex">
          <el-form-item class="form-flex-item" prop="bankAreaCode">
            <select-page
              class="bankSelect"
              :value="form.bankAreaCode"
              :request-data="bankAreaReq"
              placeholder="请选择省"
              option-value="areaCode"
              option-name="areaName"
              :pagination="false"
              valueName="bankArea"
              remoteKey="areaName"
              requestUrl="getAreaCode"
              :disabled="readOnly"
              @getSelect="setBankPro"></select-page>
          </el-form-item>
          <el-form-item class="form-flex-item" prop="bankCityCode">
            <select-page
              class="bankSelect"
              :value="form.bankCityCode"
              :request-data="bankCityReq"
              placeholder="请选择市"
              option-value="areaCode"
              option-name="areaName"
              :disabled="readOnly"
              :pagination="false"
              valueName="bankCity"
              remoteKey="areaName"
              :begin-init="cityBeginInit"
              @getSelect="setBankCity"
              requestUrl="getAreaCode"></select-page>
          </el-form-item>
          <el-form-item prop="bankBranchCode">
            <select-page
              class="branch-input"
              :value="form.bankBranchCode"
              :request-data="branchReq"
              placeholder="请选择分行网点"
              option-value="unionpayCode"
              option-name="branchName"
              :disabled="readOnly"
              valueName="bankBranch"
              remoteKey="branchName"
              :begin-init="branchBeginInit"
              @getSelect="setBankArea"
              label="分行网点"
              requestUrl="getBranch"></select-page>
          </el-form-item>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import qs from 'qs'
import selectPage from '@/components/selectPage'
import { validBankCard } from '@/api/global'
export default {
  name: 'BankBranch',
  components: {
    selectPage
  },
  props: {
    value: {
      type: Object,
      default: function () {
        return {
          // bankName:'',//银行类型
          // bankArea:'',//银行网点省
          // bankCity:'',//银行网点市
          // bankBranch:'',//分行网点
          bankNameCode: '', // 银行类型编码
          bankCityCode: '', // 银行类型编码
          bankAreaCode: '', // 银行类型编码
          bankBranchCode: ''// 分行id
        }
      }
    },
    // 表单label长度
    labelWidth: {
      type: String,
      default: '100px'
    },
    // 是否可以编辑
    readOnly: {
      type: Boolean,
      default: false
    },
    // 银行卡号，如果有，就联动银行
    bankCardId: {
      type: String,
      default: ''
    },
    showTips: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bank_list: [], // 开户行类型列表
      bank_pro_list: [], // 银行网点省列表
      bank_city_list: [], // 银行网点市列表
      branch_list: [], // 银行网点
      form: {
        // bankName:'',//银行类型
        // bankArea:'',//银行网点省
        // bankCity:'',//银行网点市
        // bankBranch:'',//分行网点
        bankNameCode: '', // 银行类型编码
        bankCityCode: '', //
        bankAreaCode: '',
        bankBranchCode: ''// 分行id
      },
      bankTypeCode: '', // 联动的银行名称
      bankTypeError: false, // 银行名称是否正确
      rule_data: {
        bankNameCode: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请选择开户行'))
            } else {
              if (this.bankTypeCode && value !== this.bankTypeCode) {
                this.bankTypeError = true
              } else {
                this.bankTypeError = false
              }
              callback()
            }
          },
          required: !this.readOnly,
          trigger: 'change'
        }],
        bankAreaCode: [{
          required: !this.readOnly,
          message: '请选择省份',
          trigger: 'change'
        }],
        bankCityCode: [{
          required: !this.readOnly,
          message: '请选择市级',
          trigger: 'change'
        }],
        bankBranchCode: [{
          required: !this.readOnly,
          message: '请选择分行网点',
          trigger: 'change'
        }]
      },
      bankAreaReq: {
        areaLevel: 1
      }, // 银行网点省的请求数据
      bankListReq: {
        bankName: ''
      }// 银行列表请求数据，本来可以为空对象，但是为了获取初始列表
    }
  },
  watch: {
    bankTypeCode (val, oldVal) {
      this.form.bankNameCode = val
    },
    form: {
      handler (val, oldVal) {
        this.$emit('getValue', val)
      },
      deep: true
    },
    value: {
      handler (val, oldVal) {
        this.form = val
      },
      deep: true
    },
    bankCardId (val, oldVal) {
      this.checkBankCardId()
    },
    bankTypeError (val, oldVal) {
      this.$emit('error', val)
    }
  },
  mounted () {
    this.form = this.value
  },
  computed: {
    // 加载城市列表的请求数据
    bankCityReq () {
      if (this.form.bankAreaCode) {
        return {
          areaLevel: 2,
          parentCode: this.form.bankAreaCode
        }
      } else {
        return {}
      }
    },
    // 是否开始加载市列表
    cityBeginInit () {
      if (JSON.stringify(this.bankCityReq) !== '{}') {
        return true
      } else {
        return false
      }
    },
    // 加载分支列表的请求数据
    branchReq () {
      if (this.form.bankNameCode && this.form.bankNameCode && this.form.bankAreaCode && this.form.bankCityCode) {
        return {
          finInstitutionCode: this.form.bankNameCode,
          cftAreaCode: this.form.bankAreaCode,
          cftCityCode: this.form.bankCityCode
        }
      } else {
        return {}
      }
    },
    // 是否开始加载分支列表
    branchBeginInit () {
      if (JSON.stringify(this.branchReq) !== '{}') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 设置银行名称
    setBankName (result) {
      if (result) {
        this.form.bankName = result.name
        this.form.bankNameCode = result.value
      }
      this.form.bankAreaCode = ''
      this.form.bankCityCode = ''
      this.form.bankBranchCode = ''
    },
    // 设置省
    setBankPro (result) {
      if (result) {
        // this.form.bankArea = result.name;
        this.form.bankAreaCode = result.value
      }
      // this.form.bankCity = '';
      this.form.bankCityCode = ''
      // this.form.bankBranch = '';
      this.form.bankBranchCode = ''
    },
    // 设置市
    setBankCity (result) {
      if (result) {
        // this.form.bankCity = result.name;
        this.form.bankCityCode = result.value
        if (this.form.bankCityCode && !this.form.bankNameCode) {
          this.$message({
            message: '请先选择开户行！',
            type: 'warning'
          })
        }
      }
      // this.form.bankBranch = '';
      this.form.bankBranchCode = ''
    },
    /**
             * 选择银行支行
             */
    setBankArea (result) {
      if (result) {
        // this.form.bankBranch = result.name;
        this.form.bankBranchCode = result.value
      }
    },
    /**
             * @description  开户号校验获取开户行
             */
    checkBankCardId () {
      const that = this
      let param = {
        bankCardId: this.bankCardId
      }
      param = qs.stringify(param)
      validBankCard(param).then(response => {
        if (parseInt(response.result_cde) === 0 && response.data.finInstitutionCode) {
          const data = response.data
          // that.form.bankName = data.bankName;
          that.bankTypeCode = data.finInstitutionCode
          that.form.bankNameCode = data.finInstitutionCode
        } else if (parseInt(response.result_cde) === 0 && !response.data.finInstitutionCode) {
          that.$message({
            showClose: true,
            message: '找不到对应的银行类型，请手动选择',
            type: 'warning'
          })
        } else {
          that.$message({
            showClose: true,
            message: response.result_msg,
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
    .form-tip-label {
        margin-left:20px;
        vertical-align:middle;
        display:inline-block;
        color:#5a5e66;
        font-size:14px;
        font-family:Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
    }
    .form-flex-item {
        margin-right: 5px;
    }
    .bankSelect{
        width: 120px;
    }
    .branch-input{
        width:255px;
    }
</style>
